import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

// One line per leaf block. `ul` and `ol` are absent so a list yields one line per item.
const BLOCK_LINE_SELECTOR = 'p, div, li, h1, h2, h3, h4, h5, h6, blockquote, pre, tr';

const NON_BREAKING_SPACE_REGEX = /\u00a0/g;

/**
 * Turns a rich text body back into the plain text a screen outside the editor can display, the
 * inverse of {@link plainTextToEmailHtml}.
 *
 * Only the text survives; bold, lists and alignment are gone by definition.
 */
export function emailHtmlToPlainText(value: string | Nullish): string {
  if (isNil(value) || value === '') {
    return '';
  }

  const {body} = new DOMParser().parseFromString(value, 'text/html');

  body.querySelectorAll('br').forEach((lineBreak) => lineBreak.replaceWith('\n'));

  const blocks = Array.from(body.querySelectorAll(BLOCK_LINE_SELECTOR)).filter((block) =>
    isNil(block.querySelector(BLOCK_LINE_SELECTOR))
  );

  if (blocks.length === 0) {
    return normalizeLine(body.textContent);
  }

  return blocks
    .map((block) => normalizeLine(block.textContent))
    .join('\n')
    .trimEnd();
}

// Trimming turns Quill's empty paragraph, `<p><br></p>`, into a blank line.
function normalizeLine(text: string | null) {
  return (text ?? '').replace(NON_BREAKING_SPACE_REGEX, ' ').trim();
}
